<template>
<section>
	<!--swiper-->
	<swiper :options="swiperOption" ref="mySwiper" v-if="swiperSlides.length > 0">
		<!-- slides -->
		<swiper-slide v-for="slide in swiperSlides" :key="slide.index">
			<div class="count-wrap " 
			v-bind:class="{greenstyle:slide.foodUseable < 55,bluestyle:slide.foodUseable >= 55 && slide.foodUseable <= 70}">
				<div class="count-inner">
					<div class="count-text">血糖指数</div>
					<div class="count-num"><span v-bind:class="{hightip:slide.foodUseable > 70}">{{slide.foodUseable}}</span></div>
				</div>
			</div>
			<div class="result-wrap text-center">
				<div class="gis-title ellipsis">{{slide.foodTitle}}</div>
				<div class="result-thumb gis-thumb" v-if="slide.foodThumb">
					<img :src="slide.foodThumb">
				</div>
				<div class="result-time gis-resultip" v-if="slide.foodUseable > 70">
					属于高血糖生成指数食物，建议少吃
				</div>
				<div class="result-time gis-resultip" v-if="slide.foodUseable < 55">
					属于低血糖生成指数食物，建议多吃
				</div>
				<div class="result-time gis-resultip" v-if="slide.foodUseable >= 55 && slide.foodUseable <= 70">
					属于中等血糖生成指数食物，建议适量食用
				</div>
			</div>
		</swiper-slide>
		<!-- Optional controls -->
		<div class="swiper-pagination" slot="pagination"></div>
		<div class="swiper-button-prev" slot="button-prev"></div>
		<div class="swiper-button-next" slot="button-next"></div>
	</swiper>
	<!--end swiper-->
	<div class="calculate-link" @click="gohome()">返回首页</div>
</section>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    components: {
    	swiper,
    	swiperSlide
    },
    data () {
      return {
      	swiperSlides: [],
      	startVal: 0,
      	theseparator:'',
        swiperOption: {
          autoplay: false,
          setWrapperSize :true,
          pagination : '.swiper-pagination',
          paginationClickable :true,
          mousewheelControl : true,
          observeParents:true,
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    head: {
		title: function () {
			return {
				inner: '血糖指数',
				separator: ' ', 
        		complement: ' '
			}
		}
	},
    created(){
    	this.swiperSlides = this.$store.state.gisfoodlist
    },
    methods:{
    	gohome(){
    		this.$router.replace({ path: '/sugarindex'});
    	}
    }
  }
</script>





// WEBPACK FOOTER //
// gis.vue?59c36b7f